@if(isPageInitialized) {
  <ng-container *transloco="let t; prefix: 'assetOverview'">
  <div class="dashboard-top-section d-flex align-items-center justify-content-between">
    <h1>{{ t('page.title') }}</h1>

    <div class="search-menu-lists d-flex">
      <div class="filters d-flex align-items-center gap-2">
        <app-account-filter [filter]="accountFilter" (filterChanged)="onAccountFilterChange($event)"
          (loadFailed)="onAccountFilterLoadFailed()"></app-account-filter>

        <div class="common-drop-down date-height">
          <app-date-filter [filter]="dateFilter" [isButtonIntervalSelector]="false"
            [disabledIntervals]="disabledIntervals" [defaultInterval]="defaultInterval"
            (filterChanged)="onDateFilterChange($event)">
          </app-date-filter>
        </div>
      </div>
    </div>
  </div>

  <div class="dashboard-widgets" [class.d-none]="hasAccountFilterError">
    <div class="row">
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-total-assets></app-total-assets>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-operational-assets></app-operational-assets>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-assets-in-maintenance></app-assets-in-maintenance>
      </div>
      <div class="col-lg-3 col-md-6 col-sm-12">
        <app-fleet-utilisation></app-fleet-utilisation>
      </div>
    </div>
  </div>

  <div class="bottom-grid-section">
    <div class="bottom-grid-sec-left">
      <div class="filter-container pb-3 d-flex w-full justify-content-between">
        <div class="w-50">
          <app-search [placeholder]="t('filters.searchPlaceholder')" [disabled]="isLoading" (searchTermUpdated)="onSearchTermUpdate($event)"
            [searchTerm]="searchTerm" [customWidth]="'390px'">
          </app-search>
        </div>

        <div class="d-flex align-items-center gap-2">
          <span ngbDropdown class="asset-status-filter" [autoClose]="true">
            <button type="button" class="btn assets-status-filter form-control dropdown-toggle search-input"
              [disabled]="isLoading" id="assetsStatusFilterDropdown" ngbDropdownToggle>
              <div class="d-flex flex-row justify-content-between dropdown-inner">
                <span class="align-middle">{{ assetStatusLabel }}</span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
    
            </button>
            <div ngbDropdownMenu aria-labelledby="assetsStatusFilterDropdown">
              <div class="d-flex flex-column">
                <button class="btn btn-outline" (click)="onAssetStatusFilter(null)" ngbDropdownItem>{{ t('filters.allStatuses') }}</button>
                <button class="btn btn-outline" (click)="onAssetStatusFilter(assetStatusFilter.Operational)" ngbDropdownItem>{{ t('status.operational') }}</button>
                <button class="btn btn-outline" (click)="onAssetStatusFilter(assetStatusFilter.InMaintenance)" ngbDropdownItem>{{ t('status.inMaintenance') }}</button>
              </div>
            </div>
          </span>
          <span ngbDropdown class="asset-type-filter" [autoClose]="true">
            <button type="button" class="btn assets-type-filter form-control dropdown-toggle search-input"
              [disabled]="isLoading" id="assetsTypeFilterDropdown" ngbDropdownToggle>
              <div class="d-flex flex-row justify-content-between dropdown-inner">
                <span class="align-middle">{{ assetTypeLabel }}</span>
                <i class="ph ph-caret-down lh-base"></i>
              </div>
            </button>
            <div ngbDropdownMenu aria-labelledby="assetsTypeFilterDropdown">
              <div class="d-flex flex-column">
                @for (option of assetTypeOptions; track option.label) {
                  <button
                    class="btn btn-outline"
                    (click)="onAssetTypeFilter(option.value)"
                    ngbDropdownItem>{{ option.label }}
                  </button>
                }
              </div>
            </div>
          </span>
        </div>
      </div>
      <div class="main-table asset-overview-table">
        <table class="table" [class.show-last-border]="showLastRowBorder">
          <thead>
            <tr>
              <th class="asset">{{ t('table.asset') }}</th>
              <th class="current-location">{{ t('table.currentLocation') }}</th>
              <th class="compliance">{{ t('table.compliance') }}</th>
              <th class="maintenance-model">{{ t('table.maintenanceModel') }}</th>
              <th class="service-type">{{ t('table.serviceType') }}</th>
              <th class="last-service">{{ t('table.lastService') }}</th>
              <th class="next-service">{{ t('table.nextService') }}</th>
              <th class="status">{{ t('table.status') }}</th>
            </tr>
          </thead>
          @if(isLoading && page === 1) {
            <tbody 
              class="spinner-container d-flex align-items-center justify-content-center spinner-border">
            </tbody>
          }
          @if(!isLoading || (isLoading && page > 1)) {
            <tbody infiniteScroll [scrollWindow]="false" (scrolled)="onScrollDown()" [infiniteScrollDistance]="2" [infiniteScrollThrottle]="300">
              @if(hasError) {
                <span class="table__no-data">
                  <app-error-state></app-error-state>
                </span>
              } @else if(!assetsDetails.length) {
                <span class="table__no-data">
                  <app-empty-state></app-empty-state>
                </span>
              }
              @for(row of assetsDetails; track row.assetId) {
                <tr (click)="onAssetClick(row.assetId, row.assetName)">
                  <td class="asset">
                    <div class="asset-cell">
                      @if(row.assetType === assetTypeFilter.Truck) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132049" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132049)">
                              <path d="M17.8408 15.542C18.8175 15.5925 19.5534 16.2818 19.5645 17.249C19.5758 18.2367 18.8376 18.9922 17.7598 19C16.7963 19.007 15.9653 18.2699 15.9824 17.2705C15.9251 16.3727 16.7878 15.4876 17.8408 15.542Z" fill="#9FA1A4"/>
                              <path d="M7.08985 15.5469C8.0469 15.589 8.77133 16.2961 8.79785 17.2559C8.77797 18.2801 8.01982 18.9902 7.00782 18.9981C6.02982 19.005 5.2095 18.3163 5.20801 17.252C5.20667 16.3169 5.98038 15.4982 7.08985 15.5469Z" fill="#9FA1A4"/>
                              <path d="M18.6016 7.9795C18.8533 7.98133 19.0975 8.06001 19.2666 8.26075C19.7111 8.78706 21.8339 11.6268 22 12.1172C21.9984 13.5352 21.9981 14.9543 21.9981 16.3731H22C21.8343 16.7734 21.527 16.9394 21.084 16.9033C20.8777 16.8858 20.6684 16.8994 20.4541 16.8994C20.3273 16.2981 20.0737 15.7732 19.6016 15.3574C19.1632 14.9704 18.6579 14.7491 18.0664 14.6709C17.5969 14.609 17.1676 14.6973 16.7412 14.8604C16.2705 15.0411 15.8861 15.3272 15.5947 15.7266C15.3609 16.0462 15.1851 16.3905 15.1221 16.7813C15.1036 16.8934 15.024 16.9113 14.9229 16.8994C14.6085 16.8642 14.3057 16.5525 14.3057 16.2451C14.3034 13.7044 14.3031 11.1635 14.3057 8.62306C14.3065 8.29608 14.6672 7.97938 15.0488 7.97755C16.2332 7.97198 17.4172 7.97068 18.6016 7.9795Z" fill="#9FA1A4"/>
                              <path d="M8.36719 5.00001C9.79535 4.99993 11.2235 5.00037 12.6514 5.00196C13.2365 5.00316 13.5676 5.32601 13.5664 5.88868L13.5674 5.88966C13.5624 9.2916 13.5636 12.6932 13.5645 16.0938C13.5644 16.4586 13.4092 16.7228 13.0518 16.8633C13.0114 16.8791 12.9671 16.8983 12.9248 16.8984C11.8449 16.9004 10.7646 16.9004 9.6709 16.9004C9.59105 16.2908 9.30531 15.778 8.85547 15.3701C8.30376 14.8693 7.62864 14.5965 6.86621 14.6475C5.50964 14.7378 4.50271 15.7152 4.33301 16.9004H2.74121C2.70668 16.9009 2.6753 16.8975 2.64356 16.8945L2.6416 16.8984C2.63104 16.8984 2.61986 16.8946 2.60938 16.8926C2.60307 16.8915 2.59712 16.8907 2.59082 16.8897C2.58514 16.8881 2.57893 16.8866 2.57325 16.8848C2.29124 16.832 2.12112 16.6346 2 16.3731V11.168L2.00293 11.165C2.00293 9.40643 2.00256 7.64754 2 5.88868C1.99885 5.32594 2.32967 5.00317 2.91504 5.00196C4.34266 5.00037 5.77046 5.00083 7.19825 5.00099L8.36719 5.00001Z" fill="#9FA1A4"/>
                            </g>
                          </svg> 
                        </span>
                      } @else if(row.assetType === assetTypeFilter.Trailer) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132050" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132050)">
                              <path d="M20.9795 14.5781V16.5332H20.6172C20.6172 17.3332 19.9591 18 19.1201 18C18.3039 17.9999 17.624 17.3554 17.624 16.5332H17.4199C17.4199 17.3332 16.7619 18 15.9229 18C15.1066 17.9999 14.4268 17.3554 14.4268 16.5332H10.1406C10.1406 17.3332 9.48256 18 8.64355 18C7.82741 17.9998 7.14746 17.3553 7.14746 16.5332H6.94336C6.94336 17.3332 6.2853 18 5.44629 18C4.63013 17.9998 3.9502 17.3553 3.9502 16.5332H2.99805V14.5781H20.9795Z" fill="#9FA1A4"/>
                              <path d="M22 6V14.2002H2V6H22Z" fill="#9FA1A4"/>
                            </g>
                          </svg>                    
                        </span>
                      } @else if(row.assetType === assetTypeFilter.Generator) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132051" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132051)">
                              <path d="M22 7V16.8652H21.0049V17.7285H2.99512V16.8652H2V7H22ZM3 8.24707V14.8613H9.88184V8.24707H3ZM6.14258 10.9502H7.64551L5.02441 14.4551L5.82812 11.9609H4.3252L5.73438 8.85156H7.1377L6.14258 10.9502Z" fill="#9FA1A4"/>
                            </g>
                          </svg>                    
                        </span>
                      } @else if(row.assetType === assetTypeFilter.Car) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_29044_98163" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_29044_98163)">
                              <path d="M6.35925 16.4997C7.16742 16.4997 7.82257 15.8157 7.82257 14.9719C7.82257 14.1281 7.16742 13.4441 6.35925 13.4441C5.55108 13.4441 4.89594 14.1281 4.89594 14.9719C4.89594 15.8157 5.55108 16.4997 6.35925 16.4997Z" fill="#9FA1A4"/>
                              <path d="M16.6991 16.4997C17.5073 16.4997 18.1624 15.8157 18.1624 14.9719C18.1624 14.1281 17.5073 13.4441 16.6991 13.4441C15.8909 13.4441 15.2358 14.1281 15.2358 14.9719C15.2358 15.8157 15.8909 16.4997 16.6991 16.4997Z" fill="#9FA1A4"/>
                              <path d="M21.2337 14.9378C20.494 14.9378 19.7704 14.9719 19.0387 14.9719H18.8377C18.7573 14.9719 18.6849 14.9037 18.6769 14.8183C18.6045 13.7258 17.7201 12.8552 16.6588 12.8552C15.5895 12.8552 14.7131 13.7258 14.6407 14.8183C14.6327 14.9037 14.5684 14.9719 14.4799 14.9719H8.54625C8.46585 14.9719 8.39349 14.9037 8.38545 14.8183C8.31308 13.7258 7.42866 12.8552 6.36736 12.8552C5.30605 12.8552 4.42163 13.7258 4.34926 14.8183C4.34122 14.9037 4.2769 14.9719 4.18846 14.9719L2.65278 14.9122C2.25077 14.9207 2.04173 14.6817 2.01761 14.3147C2.01761 12.8762 2.14267 13.4351 2.13959 13.1771C2.12919 12.3049 2.12487 11.3388 2.12487 10.8579C2.12487 10.8579 2.00153 10.7384 2.00153 10.6616C2.00153 10.5165 2.17037 10.397 2.31509 10.397L4.60264 10.1308C5.57714 8.74873 7.14521 7.70336 7.7573 7.5L10.7573 7.5C10.7573 7.5 10.8297 7.50355 10.9181 7.50355C12.1 7.50355 12.8608 7.49501 13.1905 7.50355C13.4558 7.50355 16.0142 10.1119 16.0946 10.1802C16.6162 10.1802 21.5746 10.9415 21.6872 11.6073C21.6952 11.6755 21.7113 11.7609 21.7113 11.8377C21.7113 11.8377 21.7965 12.3516 21.7965 13.0344C21.7965 13.2393 21.9975 13.0942 21.9975 13.2905C21.9975 13.5039 21.9975 14.144 21.9975 14.3147C21.9734 14.6988 21.5955 14.9378 21.2337 14.9378Z" fill="#9FA1A4"/>
                            </g>
                          </svg>           
                        </span>
                      } @else if(row.assetType === assetTypeFilter.Motorbike) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132052" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132052)">
                              <path d="M5.91895 12.0343C7.59807 12.0343 8.95996 13.3953 8.95996 15.0744C8.95991 16.7535 7.59804 18.1144 5.91895 18.1144C4.23998 18.1143 2.87896 16.7534 2.87891 15.0744C2.87891 13.3954 4.23995 12.0345 5.91895 12.0343Z" fill="#9FA1A4"/>
                              <path d="M18.96 12.0343C20.6389 12.0345 22 13.3954 22 15.0744C21.9999 16.7533 20.6389 18.1143 18.96 18.1144C17.2809 18.1144 15.92 16.7534 15.9199 15.0744C15.9199 13.3953 17.2809 12.0343 18.96 12.0343Z" fill="#9FA1A4"/>
                              <path d="M17.0078 6.00798L19.3477 8.56462L19.958 10.5099C14.3948 11.0533 15.2744 17.005 15.2744 17.005H9.60742V15.9181C9.96966 10.8467 5.13086 10.8468 5.13086 10.8468L2.72461 8.54313H2.00098V7.71599H5.0791L6.03711 8.72478C6.88605 9.93379 9.32078 9.78704 9.34863 9.78532C11.755 6.52521 13.3124 9.69218 15.2998 8.51774C17.2873 7.34281 17.2881 7.34294 17.2881 7.34294L16.6885 6.14274C16.5934 5.95124 17.0078 6.00798 17.0078 6.00798Z" fill="#9FA1A4"/>
                            </g>
                          </svg>                    
                        </span>
                      } @else if(row.assetType === assetTypeFilter.YellowEquipment) { 
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132055" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132055)">
                              <path d="M21.0041 11H18.0163V7H13.0366L10.0489 11V16H22L21.0041 11ZM11.5826 11L13.5346 8.5H16.0244V11H11.5826ZM9.80983 3.41L4.83019 2L2.08143 11.83C1.74281 13.11 2.48976 14.44 3.77451 14.8L4.92978 15.12L8.20639 12.29L4.34219 11.21L6.21453 4.46L8.99317 5.24C9.55089 5.53 10.756 6.34 11.5129 7.37L12.5387 6H12.9769C11.722 4.41 9.89947 3.46 9.80983 3.41Z" fill="#9FA1A4"/>
                              <path d="M4 19.5C4 18.1193 5.11929 17 6.5 17H18.5C19.8807 17 21 18.1193 21 19.5C21 20.8807 19.8807 22 18.5 22H6.5C5.11929 22 4 20.8807 4 19.5Z" fill="#9FA1A4"/>
                            </g>
                          </svg>             
                        </span>
                      } @else if(row.assetType === assetTypeFilter.Van) {
                        <span>
                          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_18973_132053" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                              <rect width="24" height="24" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_18973_132053)">
                              <path d="M6.36127 16.4997C7.16943 16.4997 7.82458 15.8157 7.82458 14.9719C7.82458 14.1281 7.16943 13.4441 6.36127 13.4441C5.5531 13.4441 4.89795 14.1281 4.89795 14.9719C4.89795 15.8157 5.5531 16.4997 6.36127 16.4997Z" fill="#9FA1A4"/>
                              <path d="M16.7011 16.4997C17.5093 16.4997 18.1644 15.8157 18.1644 14.9719C18.1644 14.1281 17.5093 13.4441 16.7011 13.4441C15.8929 13.4441 15.2378 14.1281 15.2378 14.9719C15.2378 15.8157 15.8929 16.4997 16.7011 16.4997Z" fill="#9FA1A4"/>
                              <path d="M21.2357 14.9378C20.496 14.9378 19.7724 14.9719 19.0407 14.9719H18.8397C18.7593 14.9719 18.6869 14.9037 18.6789 14.8183C18.6065 13.7258 17.7221 12.8552 16.6608 12.8552C15.5915 12.8552 14.7151 13.7258 14.6427 14.8183C14.6347 14.9037 14.5704 14.9719 14.4819 14.9719H8.54825C8.46785 14.9719 8.39549 14.9037 8.38745 14.8183C8.31509 13.7258 7.43067 12.8552 6.36936 12.8552C5.30805 12.8552 4.42363 13.7258 4.35127 14.8183C4.34323 14.9037 4.27891 14.9719 4.19047 14.9719L2.65479 14.9122C2.25278 14.9207 2.04373 14.6817 2.01961 14.3147C1.98745 13.9562 2.00353 11.4469 2.00353 10.8238C2.00353 10.8067 2.00353 10.7384 2.00353 10.6616C2.00353 10.5165 2.17238 10.397 2.3171 10.397H10.5985C10.6869 10.397 10.7593 10.3202 10.7593 10.2263V7.67426C10.7593 7.58037 10.8317 7.50355 10.9201 7.50355C12.102 7.50355 13.8628 7.49501 14.1925 7.50355C14.4578 7.50355 17.3603 9.74834 17.4407 9.81662C17.6256 9.99586 21.5734 10.2519 21.6859 10.9177C21.694 10.986 21.7101 11.0713 21.7101 11.1481C21.7101 11.1481 21.7985 12.3516 21.7985 13.0344C21.7985 13.2393 21.9995 13.0942 21.9995 13.2905C21.9995 13.5039 21.9995 14.144 21.9995 14.3147C21.9754 14.6988 21.5975 14.9378 21.2357 14.9378Z" fill="#9FA1A4"/>
                            </g>
                          </svg>
                        </span>
                      }
                      <span class="asset-name" [attr.title]="row.assetName">{{ row.assetName }}</span>
                    </div>
                  </td>
                  <td class="current-location">
                    <p [attr.title]="row.currentLocation">{{ row.currentLocation }}</p>
                  </td>
                  <td class="compliance">
                    <div class="compliance-cell">
                      <p>{{ t('table.compliantCount', { current: row.currentCompliances, total: row.totalCompliances }) }}</p>
                      @if(shouldShowIcon(row)) {
                        <ng-container>
                          <span class="compliance-icon" #popover="ngbPopover" placement="right right-top right-bottom auto"
                            container="body"
                            [ngbPopover]="popoverContent"
                            (mouseenter)="openPopover(popover)"
                            (mouseleave)="scheduleClosePopover(popover)">
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M11.953 2C6.465 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.493 2 11.953 2ZM12 20C7.589 20 4 16.411 4 12C4 7.589 7.567 4 11.953 4C16.391 4 20 7.589 20 12C20 16.411 16.411 20 12 20Z" fill="#FF7F00"/>
                              <path d="M11 7H13V14H11V7ZM11 15H13V17H11V15Z" fill="#FF7F00"/>
                            </svg>
                          </span>
                          <ng-template #popoverContent>
                            <div class="popover-wrapper" (mouseenter)="cancelClosePopover()" (mouseleave)="scheduleClosePopover(popover)">
                              <div class="popover-title">
                                {{ t('table.nonCompliantCount', { count: row.outstandingCompliances.length }) }}
                              </div>
                              <div class="tooltip-scrollable">
                                <ul class="popover-list">
                                  @for(compliance of row.outstandingCompliances; track compliance.name) {
                                    <li>
                                      {{ compliance.name }}
                                    </li>
                                  }
                                </ul>
                              </div>
                            </div>
                          </ng-template>
                        </ng-container>
                      }
                      
                    </div>
                  </td>

                  <td class="maintenance-model">
                    <div class="two-line-cell">
                      <span>{{ getMaintenanceModelLabel(row.maintenanceModel) }}</span>
                      <span class="workshop-name" [attr.title]="row.workshopName">{{ row.workshopName }}</span>
                    </div>
                  </td>

                  <td class="service-type">
                    <p>{{ getScheduleTypeLabel(row.serviceScheduleType) }}</p>
                  </td>

                  <td class="last-service">
                    <div class="two-line-cell">
                      <span>{{ row.lastService | date:'dd/MM/yyyy' }}</span>
                      <span class="severity" [attr.title]="getSeverityLabel(row.lastServiceSeverity)">{{ getSeverityLabel(row.lastServiceSeverity) }}</span>
                    </div>
                  </td>

                  <td class="next-service">
                    <div class="two-line-cell">
                      <span>{{ row.nextService | date:'dd/MM/yyyy' }}</span>
                      <span class="severity" [attr.title]="getSeverityLabel(row.nextServiceSeverity)">{{ getSeverityLabel(row.nextServiceSeverity) }}</span>
                    </div>
                  </td>

                  <td class="status">
                    <span class="status-badge" [ngClass]="getStatusBadgeClass(row.operationalStatus)">{{ getAssetStatus(row.operationalStatus) }}</span>
                  </td>
                </tr>
              }
              @if(page > 1 && isLoading) {
                <tr>
                  <td>
                    <div class="d-flex justify-content-center">
                      <span class="spinner-border text-light"></span>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          }
        </table>
      </div>
    </div>
  </div>
  </ng-container>
}